import ProposalFeedbacks from './ProposalFeedbacks';
export default ProposalFeedbacks;